package com.milta.core.localization.translations.sq

import com.milta.core.localization.SubscriptionStrings

internal val Subscription = SubscriptionStrings(
    screenTitle = "Abonimi im",
    screenSubtitle = "Administroni abonimin tuaj Milta",
    planDriver = "Shofer",
    planOrganisation = "Ndërmarrje",
    statusActive = "Aktiv",
    statusTrial = "Provë falas",
    statusExpired = "Skaduar",
    statusCancelled = "Anuluar",
    platformLabel = "Platforma",
    productIdLabel = "Produkti",
    expiresAtLabel = "Skadon më",
    noExpiry = "Pa datë skadimi",
    noValue = "—",
    noSubscription = "Asnjë abonim aktiv",
    activateButton = "Aktivizo abonimin",
    successActivated = "Abonimi u aktivizua me sukses",
    perMonth = "/muaj",
    pitchTitle = "Zhbllokoni të gjitha veçoritë e Milta",
    pitchSubtitle = "Zgjidhni planin e përshtatshëm për aktivitetin tuaj për të vazhduar dorëzimet dhe menaxhimin e turneve.",
    featuredBadge = "GJITHÇKA E PËRFSHIRË",
    driverFeature1 = "Turne & dorëzime të pakufizuara",
    driverFeature2 = "Dëshmi foto e dorëzimit + nënshkrim",
    driverFeature3 = "Njoftime në kohë reale",
    orgFeature1 = "Menaxhim i pakufizuar i ekipit",
    orgFeature2 = "Panel i plotë në web",
    orgFeature3 = "Importim turnesh (Excel, PDF, foto)",
    orgFeature4 = "Qasje si Shofer e përfshirë për ju",
    purchaseFinePrint = "Pagesë e sigurt përmes dyqanit. Anulohet në çdo kohë nga cilësimet e dyqanit.",
    purchasingLabel = "Duke procesuar…",
    activeCaption = "Abonimi juaj Milta",
    nextRenewalLabel = "Rinovimi tjetër",
    includedTitle = "Përfshirë në planin tuaj",
    manageOnGooglePlay = "Menaxho në Google Play",
    manageOnAppStore = "Menaxho në App Store",
    viewTechnicalDetails = "Shiko detajet teknike",
    monthNames = listOf("janar", "shkurt", "mars", "prill", "maj", "qershor", "korrik", "gusht", "shtator", "tetor", "nëntor", "dhjetor"),
    errorNotFound = "Nuk u gjet asnjë abonim aktiv",
    errorConflict = "Ekziston tashmë një abonim aktiv për këtë llogari",
    errorPlanMismatch = "Plani i zgjedhur nuk përputhet me rolin e llogarisë suaj",
    errorPlanRequired = "Zgjidhni një plan",
    errorPlanInvalid = "Plani i zgjedhur është i pavlefshëm",
    errorPlatformRequired = "Platforma është e nevojshme",
    errorPlatformInvalid = "Platformë e pavlefshme. Duhet të jetë AppStore ose GooglePlay",
    errorStoreProductIdRequired = "ID-ja e produktit të dyqanit është e nevojshme",
    errorReceiptTokenRequired = "Token-i i faturës është i nevojshëm",
    errorGeneric = "Ndodhi një gabim. Ju lutemi provoni përsëri.",
    trialBannerDaysPrefix = "🎉 Provë falas: ju kanë mbetur ",
    trialBannerDaysBold = "%d ditë",
    trialBannerDaysSuffix = " për të zbuluar Milta pa asnjë angazhim.",
    trialBannerHoursPrefix = "⏰ Prova juaj falas përfundon brenda ",
    trialBannerHoursBold = "%d orë",
    trialBannerHoursSuffix = ": abonohuni për të vazhduar të përdorni Milta pa ndërprerje.",
)
